const _excluded = ["className", "items", "bgColor"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cn from 'classnames';
import { actionColumnDef, expandIconStyle, useTableListContext } from "./TableList.utils";
import { TableListItem } from "./TableListItem";
import { TableListSortIcons } from "./TableListSortIcons";
import { TableListHeaderItem } from "./TableListHeaderItem";
import styles from "./TableList.module.scss";
import { Checkbox } from "../Checkbox";
const defaultSortOrder = ['desc', 'asc'];

function getNextSort(sort, sortOrder) {
  if (!sort) {
    return sortOrder[0];
  }

  const idx = sortOrder.findIndex(so => so === sort.sort);
  return sortOrder[(idx + 1) % sortOrder.length];
}

export function TableListHeader(props) {
  const {
    className,
    items,
    bgColor = 'gray'
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const {
    columnDefs,
    expandableRows,
    enableRowSelection,
    sort,
    hasActionColumn,
    numRows,
    numSelectedRows,
    onToggleAllSelection,
    setSort
  } = useTableListContext();
  const testid = rest['data-testid'];
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cn(styles.header, styles["".concat(bgColor, "Bg")], className),
    "data-testid": testid
  }), !!enableRowSelection && /*#__PURE__*/React.createElement(Checkbox, {
    "data-testid": testid && "".concat(testid, "-checkbox"),
    checked: numRows != null && numRows === numSelectedRows,
    partiallyChecked: numSelectedRows != null && numSelectedRows > 0 && numSelectedRows !== numRows,
    onChange: e => {
      e.stopPropagation();

      if (onToggleAllSelection != null) {
        onToggleAllSelection(e.target.checked);
      }
    }
  }), items.map((item, idx) => {
    if (!columnDefs[idx]) return null;
    const isSortable = columnDefs[idx].sortable;
    const isSorted = sort && idx === sort.colIndex;
    return /*#__PURE__*/React.createElement(TableListHeaderItem, {
      key: idx,
      columnDef: columnDefs[idx],
      item: item,
      "data-testid": testid && "".concat(testid, "-").concat(idx)
    }, isSortable && /*#__PURE__*/React.createElement("button", {
      className: cn(styles.sortable, {
        [styles.sortActive]: isSorted
      }),
      "data-testid": testid && "".concat(testid, "-").concat(idx, "-sort-").concat(isSorted && sort ? sort.sort : 'none'),
      onClick: () => {
        const nextSort = getNextSort(isSorted ? sort : undefined, columnDefs[idx].sortOrder || defaultSortOrder);
        setSort(nextSort && {
          colIndex: idx,
          sort: nextSort
        });
      }
    }, item.value, /*#__PURE__*/React.createElement(TableListSortIcons, {
      sort: isSorted ? sort.sort : undefined
    })));
  }), hasActionColumn && /*#__PURE__*/React.createElement(TableListItem, {
    columnDef: actionColumnDef,
    item: {
      value: ''
    },
    "data-testid": rest['data-testid'] && "".concat(rest['data-testid'], "-action-column")
  }), expandableRows && /*#__PURE__*/React.createElement("div", {
    style: expandIconStyle
  }));
}